import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import api from '../../../../utils/api';
import { AllStaffHistoryTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import Swal from 'sweetalert2';
// import BookingHistoryFilterHeader from '../../../../Componant/Application/Ecommerce/ProductList/BookingHistoryFilterHeader';
import { AllStaffHistoryTableStatus, StaffHistoryTableAction } from '../../../../Data/Application/Ecommerce/AllStaffHistory';
import { useNavigate } from 'react-router-dom';

const AllStaffHistoryContainer = () => {
  const navigate = useNavigate();
  const [filterText, setFilterText] = useState("");
  const [bookingHistoryTableDatas, setBookingHistoryTableDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const fetchStaffs = async (page: number, size: number) => {
    setLoading(true);
    try {
      const response = await api.get(`/api/Auth/GetAllStaffPagination?pageNumber=${page}&pageSize=${size}`);
      if (response.status === 200) {
        setBookingHistoryTableDatas(response.data.items.map((item: any): AllStaffHistoryTableDataColumnType => ({
          userId: item.userId,
          staffName: item.staffName,
          staffId: item.staffId,
          staffRole: item.staffRole,
          staffEmail: item.staffEmail,
          staffPhone: item.staffPhone,
          counterStatus: item.counterStatus,
          isActive: item?.isActive === false ? "Inactive" : "Active",
          staffJoiningDate: new Date(item?.staffJoiningDate).toISOString().split('T')[0],
          staffPost: item.staffPost || "N/A", // Assuming staffPost is optional
        })));
        setTotalRows(response.data.totalCount);
      }
    } catch (error) {
      // console.error("Failed to fetch booking history:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchStaffs(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleDelete = async (id: string) => {
    // Your delete logic here (API call, state update, etc.)
    // console.log("Deleting ID:", id);
    try {
      await api.put(`/api/Auth/DeActiveStaffRegistration?userId=${id}`);
      Swal.fire('Deactivate!', ' Staff has been deactivated successfully.', 'success');

      // Optional: refresh the list
      // setBookingHistoryTableDatas((prev) => prev.filter((item: { userId: any; }) => item.userId !== id));
      await fetchStaffs(currentPage, pageSize); // Refresh the data after deletion
    } catch (error) {
      Swal.fire('Error!', 'Failed to deactivate the staff.', 'error');
      console.error("Deactivate error:", error);
    }
  };

  const staffHistoryTableDataColumn: TableColumn<AllStaffHistoryTableDataColumnType>[] = [
    {
      name: "Name",
      selector: (row) => `${row.staffName}`,
      sortable: true,
    },
    {
      name: "Staff ID",
      cell: (row) => <AllStaffHistoryTableStatus title={row.staffId} />,
    },
    {
      name: "Mobile No.",
      cell: (row) => <AllStaffHistoryTableStatus title={row.staffPhone} />,
    },
    {
      name: "Email",
      cell: (row) => <AllStaffHistoryTableStatus title={row.staffEmail} />,
      minWidth: '200px',
    },
    {
      name: "Designation",
      cell: (row) => <AllStaffHistoryTableStatus title={row.staffPost} />,
      minWidth: '150px',
    },
    {
      name: "Permission",
      cell: (row) => <AllStaffHistoryTableStatus title={row.counterStatus} />,
    },
    {
      name: "Status",
      cell: (row) => <AllStaffHistoryTableStatus title={row.isActive} />,
    },
    {
      name: "Joining Date",
      cell: (row) => <AllStaffHistoryTableStatus title={row.staffJoiningDate} />,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span
            className="cursor-pointer text-primary p-2 rounded"
            title="Change Password"
            style={{ marginRight: 4, cursor: "pointer" }}
            onClick={() => {
              localStorage.setItem("selectedUserId", row.userId);
              navigate(`/account/ChangePassword`);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="currentColor">
              <path d="M12 17a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 17zm6-8h-1V7a5 5 0 0 0-10 0v2H6c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h6.1c.1-.3.2-.7.4-1l.5-1c.1-.2.2-.4.4-.6l5.6-5.6c.3-.3.7-.5 1.1-.6V11c0-1.1-.9-2-2-2zM8 7a4 4 0 0 1 8 0v2H8V7zm13.7 7.3a1 1 0 0 0-1.4 0l-5.6 5.6c-.1.1-.2.2-.2.4l-.5 1c-.1.3.2.6.5.5l1-.5c.1 0 .3-.1.4-.2l5.6-5.6a1 1 0 0 0 0-1.4z" />
            </svg>

          </span>
          <StaffHistoryTableAction userId={row.userId} onDelete={handleDelete} />
        </>
      ),
    },
  ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };


  const filteredItems = bookingHistoryTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
  });

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                {/* <BookingHistoryFilterHeader /> */}
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable data={filteredItems} columns={staffHistoryTableDataColumn} striped highlightOnHover pagination paginationServer paginationTotalRows={totalRows} onChangePage={handlePageChange} onChangeRowsPerPage={handlePerRowsChange} paginationDefaultPage={currentPage} paginationPerPage={pageSize} progressPending={loading} selectableRows subHeader subHeaderComponent={subHeaderComponentMemo} />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default AllStaffHistoryContainer